<template>
  <!-- <img
    src="../../assets/images/city-background.jpg"
    alt="contact-image"
    class="image-background-login"
  /> -->
  <img
    src="../../assets/images/NEWTEC_FUNDO_2.jpg"
    alt="contact-image"
    class="new-image-background-login"
  />
  <RegisterContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import RegisterContent from "../../components/Authentication/RegisterContent.vue";

export default defineComponent({
  name: "RegisterPage",
  components: {
    RegisterContent,
  },
});
</script>

<style scoped>
.new-image-background-login{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
}

img {
    max-width: unset !important;
  }

@media (max-width: 576px) {
  .new-image-background-login{
    left: -60% !important;
    width: auto;
    height: 100%;
  }
}
</style>